import { Checkbox } from '@lifeomic/chroma-react/components/Checkbox';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useLocalStorageState } from '../../../hooks';

export const REMOVE_ALL_CITATIONS_STORAGE_KEY =
  'ai-template-remove-all-citations-after-generation';

const messages = defineMessages({
  removeAllCitations: {
    id: 'ReportTemplates.GenerationMenu.removeAllCitations',
    defaultMessage: 'Remove all citations after generation',
  },
});

export const useRemoveAllCitationsPreference = () =>
  useLocalStorageState<boolean>(REMOVE_ALL_CITATIONS_STORAGE_KEY, false);

export const CitationPostProcessingOption: React.FC<{
  checked: boolean;
  onChange: (checked: boolean) => void;
}> = ({ checked, onChange }) => {
  const { formatMessage } = useIntl();
  const label = formatMessage(messages.removeAllCitations);

  return (
    <Checkbox
      label={label}
      aria-label={label}
      checked={checked}
      onChange={event => onChange(event.target.checked)}
    />
  );
};
